import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './SidebarOption.css';

const SidebarOption = props => (
  <div className={`${props.hide ? '-eva-3-hide' : ''} eva-3-row -no-gutter -eva-3-mt-lg -eva-3-mb-lg SidebarOption`}>
    <div className="col -sm-12">
      <div className={`eva-3-row -no-gutter eva-3-link ${props.disabled && '-disable'}`}>
        <Link className="-eva-3-valign" to={props.linkTo} target={props.force ? '_self' : undefined} onClick={props.onClick}>
          <span className="-eva-3-fl">
            <i className={`${props.disabled ? '-eva-3-tc-purple-3' : '-eva-3-tc-gray-1'} eva-3-icon-${props.icon}`} />
          </span>
          <div className={`col -sm-11 ${props.disabled ? '-eva-3-tc-purple-3' : '-eva-3-tc-gray-1'}`}>
            <p className="-eva-3-bold -lh-3 -fs-1 -eva-3-fl"> {props.title} </p>
          </div>
        </Link>
      </div>
    </div>
    {
        props.text && (
          <div className="col -sm-12 -eva-3-mt-xsm -content">
            <p className="-eva-3-tc-gray-1 -fs-1 -lh-1"> {props.text} </p>
          </div>
        )
      }
  </div>
);

SidebarOption.defaultProps = {
  text: undefined,
  hide: false,
  force: false,
  disabled: false,
  onClick: () => {},
};

SidebarOption.propTypes = {
  hide: PropTypes.bool,
  linkTo: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  force: PropTypes.bool,
  disabled: PropTypes.bool,
  track: PropTypes.func,
};

export default SidebarOption;
